(function () {
  var CHARM_HANDLE = 'cherry-bag-charm';
  var checking = false;

  async function enforceCharmRule() {
    if (checking) return;
    checking = true;
    try {
      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      var charm = cart.items.filter(function (i) { return i.handle === CHARM_HANDLE; });
      var others = cart.items.filter(function (i) { return i.handle !== CHARM_HANDLE; });

      // Charm is alone in the cart -> remove it
      if (charm.length && others.length === 0) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: charm[0].key, quantity: 0 })
        });
        window.location.reload();
      }
    } catch (e) { /* ignore */ }
    checking = false;
  }

  // Check on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceCharmRule);
  } else {
    enforceCharmRule();
  }

  // Re-check after any AJAX cart change (drawer quantity/remove buttons)
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url);
    var p = origFetch.apply(this, arguments);
    if (url && /\/cart\/(change|update|add|clear)/.test(url)) {
      p.then(function () { setTimeout(enforceCharmRule, 400); });
    }
    return p;
  };
})();
